// extracted by mini-css-extract-plugin
export default {"container":"TextEditor_container__d+gFi","title":"TextEditor_title__eBqgn"};